/**
 * Figma `download-01` glyph used by artifact actions. The 12px vector is
 * centered in its 16px frame and uses `currentColor` so the enclosing button
 * controls every interaction-state tint.
 */
export type DownloadGlyphProps = {
  /** Rendered width and height in pixels. */
  size?: number;
  className?: string;
};

function DownloadGlyph({ size = 16, className }: DownloadGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 8V8.8C12 9.9201 12 10.4802 11.782 10.908C11.5903 11.2843 11.2843 11.5903 10.908 11.782C10.4802 12 9.9201 12 8.8 12H3.2C2.0799 12 1.51984 12 1.09202 11.782C0.715695 11.5903 0.409734 11.2843 0.217987 10.908C0 10.4802 0 9.9201 0 8.8V8M9.33333 4.66667L6 8M6 8L2.66667 4.66667M6 8V0"
        transform="translate(2 2)"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DownloadGlyph;
